import * as React from 'react'
import { createContainer } from 'unstated-next'

import type { FormGroup } from '@company/gen_proto/api_proto/v1/form_pb'
import type { GetStaffAuthResponse } from '@company/gen_proto/api_proto/v1/staff_pb'

interface InitialStateType {
  staff: null | GetStaffAuthResponse
  formGroups: null | FormGroup[]
  /**
   * スタッフ情報の取得（GetStaffMe）が一時的な失敗で終わったときの文言。
   * null以外かつstaffがnullのとき、root.tsxが再試行画面を出す。
   * 確定的な拒否（停止済みスタッフ等）はここではなくサインアウト + ログイン画面のバナーで扱う
   * （@company/auth/staffMeFailure.ts / @company/auth/authRejection.ts）。
   *
   * 既存の呼び出し側（story / specが渡すinitialState）を壊さないため任意にしている。
   */
  authError?: null | string
}

const initialState = {
  staff: null,
  formGroups: null,
  authError: null,
} as const

const useAppState = (state: InitialStateType = initialState) => {
  const [staff, updateStaff] = React.useState<InitialStateType['staff']>(
    state.staff ?? initialState.staff,
  )
  const [formGroups, updateFormGroups] = React.useState<InitialStateType['formGroups']>(
    state.formGroups ?? initialState.formGroups,
  )
  // 受け取りは任意（既存のstory / specを壊さない）だが、保持する値はstring | nullに揃える
  const [authError, updateAuthError] = React.useState<null | string>(
    state.authError ?? initialState.authError,
  )

  return {
    staff,
    updateStaff,
    formGroups,
    updateFormGroups,
    authError,
    updateAuthError,
  }
}

export const AppStateContainer = createContainer(useAppState)
